import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=89dd5516&scoped=true&"
import script from "./MarketPlace.vue?vue&type=script&lang=ts&"
export * from "./MarketPlace.vue?vue&type=script&lang=ts&"
import style0 from "./MarketPlace.vue?vue&type=style&index=0&id=89dd5516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd5516",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
